import { BadgeCheck } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { EXTRA, COMPANY, VAT_NOTE } from "../content/extra";

export const CompanyCard = ({ testId = "company-card" }) => {
  const { lang } = useLang();
  const c = EXTRA[lang].company;

  const rows = [
    [c.labels.name, COMPANY.name],
    [c.labels.director, COMPANY.director],
    [c.labels.address, COMPANY.address],
    [c.labels.ico, COMPANY.ico],
    [c.labels.dic, COMPANY.dic],
    [c.labels.icdph, `${COMPANY.icdph}`],
    [c.labels.register, COMPANY.register],
  ];

  return (
    <div data-testid={testId} className="border border-white/10 bg-[#0a0a0a] p-7 md:p-8">
      <div className="flex items-center gap-3 text-xs tracking-[0.25em] uppercase text-[#D4AF37] mb-6">
        <span className="h-px w-8 bg-[#D4AF37]/60" />
        {c.heading}
      </div>
      <dl className="divide-y divide-white/10">
        {rows.map(([label, value], i) => (
          <div key={i} className="grid grid-cols-3 gap-4 py-3">
            <dt className="text-xs tracking-wider uppercase text-white/40 col-span-1">{label}</dt>
            <dd className="text-white/85 col-span-2">{value}</dd>
          </div>
        ))}
      </dl>
      <div className="flex items-start gap-3 mt-6 pt-6 border-t border-white/10">
        <BadgeCheck size={20} className="text-[#D4AF37] shrink-0 mt-0.5" strokeWidth={1.5} />
        <p className="text-white/55 text-sm leading-relaxed">{EXTRA[lang].brandNote}</p>
      </div>
      <p data-testid="company-vat-note" className="text-white/40 text-xs leading-relaxed mt-4">{VAT_NOTE[lang]}</p>
    </div>
  );
};
